import { Injectable } from '@angular/core';

/**
 * Service with helper methods to work with strings
 */
@Injectable({ providedIn: 'root' })
export class StringHelperService {
    /**
     * Creates a default name which does not exist
     * @param label default label name
     * @param existingNames array with a list of already defined names
     * @param nameSuffix suffix for the name
     * @param caseSensitive maintains or not the case sensitivity of the label
     */
    getDefaultName(label: string, existingNames: string[], nameSuffix = '', caseSensitive = true): string {
        const labelRegExp = caseSensitive ? label : `${label}|${label.toLowerCase()}`;

        if (!existingNames.some((name) => new RegExp(`^${labelRegExp}(${nameSuffix})?$`).test(name))) {
            return label;
        }

        const LIMIT = 1000;
        for (let i = 2; i < LIMIT; i++) {
            const regExp = new RegExp(`^(${labelRegExp})\\s\\(${i}\\)(${nameSuffix})?$`);
            if (!existingNames.some((name) => regExp.test(name))) {
                return `${label} (${i})`;
            }
        }

        return label;
    }
}
